export default __webpack_public_path__ + "static/media/3579502.6780d9a2.jpeg";